export default "__VITE_ASSET__CwF6XM1K__"